import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Breadcrumb, Form, Row, Col } from 'react-bootstrap'
import { fetch } from "../../utils";
import axios from 'axios';
import { BASE_URL } from "../../config";

const EditProduct = () => {
    const [categoryData, setCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const getCategory = async () => {
        try {
            setLoading(true);
            const response = await fetch("category/all", "GET", null, null);
            if (response.status === 200) {
                const { success, data } = response.data;
                if (success === true) {
                    setCategoryData(data.categorys);
                } else {
                    setCategoryData([]);
                }
            } else {
                setCategoryData([]);
            }
        } catch (error) {
            setCategoryData([]);
        } finally {
            setLoading(false);
        }
    };

    const getSubCategory = async () => {
        try {
            setLoading(true);
            const response = await fetch("sub-category/all", "GET", null, null);
            if (response.status === 200) {
                const { success, data } = response.data;
                if (success === true) {
                    setSubCategoryData(data.sub_categorys);
                } else {
                    setSubCategoryData([]);
                }
            } else {
                setSubCategoryData([]);
            }
        } catch (error) {
            setSubCategoryData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCategory();
        getSubCategory();
    }, []);


    return (
        <>
            <div className="container-fluid">
                <Breadcrumb className="px-4 py-3">
                    <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
                    <Breadcrumb.Item >Products</Breadcrumb.Item>
                    <Breadcrumb.Item active>Edit</Breadcrumb.Item>
                </Breadcrumb>
                <section className="content">
                    <div className="container-fluid">
                        <Card>
                            <Card.Header>
                                <h4>
                                    Edit Product Details
                                </h4>
                            </Card.Header>
                            <CardBody>
                                <Form>
                                    <Row className="mb-3">
                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                                            <Form.Label>Select Category</Form.Label>
                                            <Form.Select
                                                aria-label="Default select example"
                                            >
                                                <option value=""> -- select -- </option>
                                                {categoryData?.map((category, index) => {
                                                    return (
                                                        <option
                                                            key={`option_${index}`}
                                                            value={category.category_id}
                                                        >
                                                            {category.category_name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                                            <Form.Label>Select Sub Category</Form.Label>
                                            <Form.Select defaultValue="Choose...">
                                                <option value=""> -- select -- </option>
                                                {subCategoryData?.map((subcategory, index) => (
                                                    <option
                                                        key={`option_${index}`}
                                                        value={subcategory.sub_category_id}
                                                    >
                                                        {subcategory.sub_category_name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridCity">
                                            <Form.Label>Product Name</Form.Label>
                                            <Form.Control type="text"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridCity">
                                            <Form.Label>Product Display Name</Form.Label>
                                            <Form.Control type="text"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridCode">
                                            <Form.Label>Product Code</Form.Label>
                                            <Form.Control type="text"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridsku">
                                            <Form.Label>Product SKU</Form.Label>
                                            <Form.Control type="text"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridMRP">
                                            <Form.Label>Product MRP</Form.Label>
                                            <Form.Control type="number"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridMSP">
                                            <Form.Label>Product MSP</Form.Label>
                                            <Form.Control type="number"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridGST">
                                            <Form.Label>Offer Price</Form.Label>
                                            <Form.Control type="number"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridGST">
                                            <Form.Label>GST</Form.Label>
                                            <Form.Control type="number"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                                            <Form.Label>Stock</Form.Label>
                                            <Form.Select defaultValue="Choose...">
                                                <option>In Stock</option>
                                                <option>Out Of Stock</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className='col-sm-3 pb-4' controlId="formGridGST">
                                            <Form.Label>Image</Form.Label>
                                            <Form.Control type="file"
                                            />
                                        </Form.Group>

                                        <Form.Group className='col-sm-6 pb-4' controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control as="textarea" rows={3} />
                                        </Form.Group>
                                        <Form.Group className='col-sm-6 pb-4' controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Additional Information</Form.Label>
                                            <Form.Control as="textarea" rows={3} />
                                        </Form.Group>
                                    </Row>


                                    <div >
                                        <Row >
                                            <Form.Group as={Col} controlId="formGridState" style={{ background: "#d7d7d7" }} className='px-2 py-2 pb-5'>
                                                <Form.Label>attribute</Form.Label>
                                                <Form.Select defaultValue="Choose...">
                                                    <option>option 1</option>
                                                    <option>option 1</option>
                                                    <option>option 1</option>
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formGridState" style={{ background: "#d7d7d7" }} className='px-2 py-2 pb-5'>
                                                <Form.Label>attribute</Form.Label>
                                                <Form.Select defaultValue="Choose...">
                                                    <option>option 1</option>
                                                    <option>option 1</option>
                                                    <option>option 1</option>
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formGridState" style={{ background: "#d7d7d7" }} className='px-2 py-2 pb-5'>
                                                <Form.Label>attribute</Form.Label>
                                                <Form.Select defaultValue="Choose...">
                                                    <option>option 1</option>
                                                    <option>option 1</option>
                                                    <option>option 1</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                    </div>
                                    <button className="btn btn-xs btn-primary text-center mt-4">Update Product</button>
                                </Form>

                            </CardBody>
                        </Card>
                    </div>
                </section>
            </div>
        </>
    )
}

export default EditProduct
